import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { functionAppsDetailed } from '../interfaces/functionApps-detailed.interface';
import { functionApps, functionAppsCreateDto } from '../interfaces/functionApps.interface';
import { FunctionAppCustomConfiguration } from '../function-apps/detailed-grid-link-functionapps/detailed-grid-link-functionapps.component';

@Injectable({
	providedIn: 'root',
})
export class FunctionAppsService {
	readonly url: string = 'functionApps';

	constructor(private http: HttpClient) {}

	public getFunctionApps(): Observable<functionApps[]> {
		return this.http.get<functionApps[]>(this.url + '/GetFunctionApps');
	}

	public GetCustomConfiguration(linkId: number): Observable<FunctionAppCustomConfiguration> {
		return this.http.get<FunctionAppCustomConfiguration>(this.url + '/GetCustomConfiguration/' + linkId);
	}

	public getfunctionAppsDetailed(): Observable<functionAppsDetailed[]> {
		return this.http.get<functionAppsDetailed[]>(this.url + '/GetFunctionAppsDetailed');
	}

	public createFunctionApps(functionApps: functionAppsCreateDto): Observable<functionApps> {
		return this.http.post<functionApps>(this.url + '/CreateFunctionApps', functionApps);
	}

	public deleteFunctionApps(functionAppsId: number): Observable<boolean> {
		return this.http.delete<boolean>(this.url + '/DeleteFunctionApps/' + functionAppsId);
	}

	public updateFunctionApps(functionApps: functionApps): Observable<boolean> {
		return this.http.post<boolean>(this.url + '/UpdateFunctionApps', functionApps);
	}
}
